var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Bar',{attrs:{"chart-id":'barChart',"options":_vm.chartOptions,"data":_vm.chartData,"plugins":_vm.plugins}})}
var staticRenderFns = []

export { render, staticRenderFns }